module.exports = __webpack_public_path__ + "img/timestudy-8.4400b2b8.png";